const category = 'AppSpecificBackOffice';

const cards = [
    {
        name: "Pend Dispute Configuration",
        id: "pendDispute",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>The following configuration will define how manual pend behavior works in the system.  The intent of this configuration is to set up the default values that will be presented to a user when pending a dispute.  It will also allow you to configure whether the pend should be in business or calendar days, and to set a maximum number of days that users are allowed to pend for.  If the default days are blank or zero, a default of 10 will be applied at runtime.  If the maximum days entered are less than the default, then a max of the default plus 5 will be used.</p>
            `,
                },
            ],
            [
                {
                    type: "contentGroup",
                    items: [
                        {
                            type: "content",
                            content: "By default, disputes will pend for",
                        },
                        {
                            type: "config",
                            id: "BOPendDisputeDefaultDays",
                        },
                        {
                            type: "config",
                            id: "BOPendDisputeCalendarType",
                        },
                        {
                            type: "content",
                            content: "and must be at least one day before the",
                        },
                        {
                            type: "config",
                            id: "BOPendDisputeRegDateThreshold",
                        },
                        {
                            type: "content",
                            content: "with the absolute maximum days to pend being",
                        },
                        {
                            type: "config",
                            id: "BOPendDisputeAbsoluteMaxDays",
                        },
                    ],
                },
            ],
        ],
    },
    {
        name: "Disposition Decision Configuration",
        id: "dispositionDecision",
        helpContent: "You can adjust recovery low dollar thresholds below. If you leave the amount as blank, then no low dollar threshold will be set. The amounts entered should be positive decimal values. If the transaction's disputed amount is less than or equal to the threshold, the dispute will pend until all recovery attempts are complete for other disputes on the claim.",
        fields: [
            [
                {
                    type: "contentGroup",
                    items: [
                        {
                            type: "content",
                            content: "The chargeback minimum for fraud disputes is",
                        },
                        {
                            type: "config",
                            id: "BODispositionFraudThreshold",
                        },
                        {
                            type: "content",
                            content: "(if blank, chargebacks will automate for all amounts)",
                        },
                    ],
                },
            ],
            [
                {
                    type: "contentGroup",
                    items: [
                        {
                            type: "content",
                            content: "The chargeback minimum for non-fraud disputes is",
                        },
                        {
                            type: "config",
                            id: "BODispositionNonFraudThreshold",
                        },
                        {
                            type: "content",
                            content: "(if blank, chargebacks will automate for all amounts)",
                        },
                    ],
                },
            ],
        ],
    },
    {
        name: "Chargeback Review Configuration",
        id: "chargebackReview",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>Set whether you would like to enable or disable chargeback review for different claim reason types below. When enabled, card disputes will stop at the Review Chargeback assignment even if there are no unsatisfied dependencies.</p>
            `,
                },
            ],
            [{ id: "BOEnableCBReviewForFraudClaims" }],
            [{ id: "BOEnableCBReviewForNonFraudClaims" }],
        ],
    },
    {
        name: "WorkBasket Routing Configuration",
        id: "workBasketRouting",
        fields: [
            [
                {
                    id: "BOWBRoutingCanMarkAssignmentAsUnworkable",
                },
            ],
            [
                {
                    id: "BOWBRoutingDoesQuavoWorkCases",
                },
            ],
            [
                {
                    type: "group",
                    groupType: "checklist",
                    label: "Quavo works",
                    items: [
                        {
                            id: "BOWBRoutingQuavoWorksCheck",
                        },
                        {
                            id: "BOWBRoutingQuavoWorksCard",
                        },
                        {
                            id: "BOWBRoutingQuavoWorksAltNetworks",
                        },
                        {
                            id: "BOWBRoutingQuavoWorksACH",
                        },
                        {
                            id: "BOWBRoutingQuavoWorksWire",
                        },
                        {
                            id: "BOWBRoutingQuavoWorksATM",
                        },
                    ],
                },
            ],
            [
                {
                    id: "BOWBRoutingSeparateAuthorizationCardClaims",
                },
            ],
            [
                {
                    id: "BOWBRoutingSeparateCardByDebitCredit",
                },
            ],
            [
                {
                    id: "BOWBRoutingSeparateATMByDebitCredit",
                },
            ],
            [
                {
                    id: "BOWBRoutingSeparateByFraudDispute",
                },
            ],
            [
                {
                    id: "BOWBRoutingSeparateByNetworkATM",
                },
            ],
            [
                {
                    id: "BOWBRoutingInvestigationToOrigUserWorklist",
                },
            ],
            [
                {
                    id: "BOWBRoutingClientPrefix",
                },
            ],
            [
                {
                    id: "BOWBRoutingUnSuffixedWBList",
                    listItems: ["BasketName"],
                },
            ],
        ],
    },
    {
        name: "Authorization Matching Configuration",
        id: "authorizationMatching",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>When set to Defined, all card transaction types are able to match to potential transactions. Product default is to
      match on transaction type.</p>
              <ul>
                  <li>When the transaction type is CardPinless it can be matched with
                      <ol>
                          <li>Transactions that post as ATMWD</li>
                          <li>Transactions that post as CardPinless</li>
                          <li>Transactions that post as CardPinned</li>
                      </ol>
                  </li>
                  <li>When the transaction type is ATMWD it can be matched with
                      <ol>
                          <li>Transactions that post as ATMWD</li>
                          <li>Transactions that post as CardPinless</li>
                          <li>Transactions that post as CardPinned</li>
                      </ol>
                  </li>
                  <li>When the transaction type is CardPinned it can be matched with
                      <ol>
                          <li>Transactions that post as ATMWD</li>
                          <li>Transactions that post as CardPinless</li>
                          <li>Transactions that post as CardPinned</li>
                      </ol>
                  </li>
                  <li>When all card transaction types are not enabled
                      <ol>
                          <li>Only matching transaction types are eligible.</li>
                      </ol>
                  </li>
              </ul>
            `,
                },
            ],
            [
                {
                    id: "IsImmediateDebitForWithdrawal",
                },
            ],
            [
                {
                    id: "EnableCreditBureauMaintenance",
                },
            ],
            [
                {
                    id: "PerformCBMPostBlockReissue",
                },
            ],
            [
                {
                    id: "IsCardNumberRequired",
                },
            ],
        ],
    },
    {
        name: "PIN Preferring Chip Card Configuration",
        tooltip: "Used when information is not received by card association",
        id: "pinPreferringChipCard",
        fields: [
            [
                {
                    id: "ChipCardDefault",
                },
            ],
            [
                {
                    id: "PinPreferringChipCardDebitDefault",
                },
            ],
            [
                {
                    id: "PinPreferringChipCardCreditDefault",
                },
            ],
        ],
    },
    {
        name: "ACH Recovery",
        id: "ACHRecovery",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>ACH Recovery can be performed with these two options:</p>
              <ol>
                  <li><strong>Advanced</strong>: This method uses enrichment to gather ACH transaction details (such as SEC code, company number, etc..) and determines the applicable return code.  Other options such as internal cross account recovery are supported.</li>
                  <li><strong>Manual</strong>: This option skips enrichment and assumes that return details are determined by the user.  Letters and accounting are still handled by QFD, as is the WSUD form.  The user <strong>must</strong> enter the resolution of the dispute (whether a return was filed or funds were recovered through another option) into QFD.</li>
              </ol>
            `,
                },
            ],
            [
                {
                    id: "UseACHProcessingOption",
                },
            ],
        ],
    },
    {
        name: "8 Digit BIN Configuration",
        id: "eightDigitBIN",
        fields: [
            [
                {
                    id: "Are8DigitBINsSupported",
                },
            ],
            [
                {
                    id: "AreOnly8DigitBINsSupported",
                },
            ],
            [
                {
                    id: "BINList",
                    listItems: ["Value"],
                },
            ],
        ],
    },
    {
        name: "Dispute Reason Configuration for Back Office Users",
        id: "disputeReason",
        fields: [
            [
                {
                    type: "group",
                    label:
                        "Select dispute types only available to back office users: (Selecting any of the dispute reasons will make them unavailable to intake users.)",
                    items: [
                        { id: "ShowAuthorizationChargebackDisputeReason" },
                        { id: "ShowCreditPostedAsDebitDisputeReasonBOOnly" },
                        { id: "ShowDebitPostedAsCreditDisputeReasonBOOnly" },
                        { id: "ShowLatePresentmentDisputeReasonBOOnly" },
                    ],
                },
            ],
        ],
    },
    {
        name: "Post-Resolution Merchant Credit Check",
        id: "postResolutionMerchantCreditCheck",
        fields: [
            [
                {
                    id: "BOEnablePostResolveMerchantCreditCheck",
                },
            ],
        ],
    },
    {
        name: "Claim Details for Audit",
        id: "claimDetailsForAudit",
        fields: [
            [
                {
                    id: "BOEnableClaimDetailAudit",
                },
            ],
        ],
    },
    {
        name: "Adding Transactions to Existing Claim",
        id: "addingTransactionsToExistingClaim",
        fields: [
            [
                {
                    id: "CanFulfillmentUsersAddTransactions",
                },
            ],
        ],
    },
    {
        name: "Claim Investigation",
        id: "claimInvestigation",
        category: "AppSpecificInvestigation",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>Prior to denying a claim, the issuer is required to perform an investigation.  QFD supports several ways of enforcing or conducting this process:</p>
              <p><strong>Anytime Investigation:</strong> Notes can be entered at any time on a fraud claim from the overview, but no specific assignment is created directing a user to complete it</p>
              <p><strong>Assignment Investigation:</strong> A specific assignment is created for each claim where notes can be entered from an investigation.  A number of findings can be required in order to complete the assignment.  If not completed, the assignment is removed upon claim resolution but can be completed from the overview at any time</p>
              <p><strong>Disabled:</strong> This functionality is not required or does not apply</p>
            `,
                },
            ],
            [{ id: "UseInvestigationOption" }],
            [{ id: "ARIAEnabled" }],
            [{ id: "ARIAAuthProfileName" }],
            [{ id: "ARIAShouldUseClientTransactionData" }],
            [{ id: "ARIAAutoDecision" }],
            [{ id: "ARIAReviewDecisionDeadlineHours" }],
            [{ id: "InvestigationNumberOfItemsRequired" }],
            [{ id: "InvestigationAllowCustomHeaders" }],
            [
                {
                    id: "InvestigationHeaderList",
                    listItems: ["Label", "AutoAddItem", "RequiredForCompletion", "FilterCriteria", "ItemList", "AllowCustomResults"],
                },
            ],
        ],
    },
    {
        name: "Denial Configuration",
        id: "denialConfiguration",
        category: "AppSpecificInvestigation",
        fields: [
            [
                {
                    id: "UseBODenyReasonConfiguration",
                    groupType: "checklist",
                    layout: [
                        [{ id: "ATMDeposit" }],
                        [{ id: "CreditVoucherAccepted" }],
                        [{ id: "DepositNotReceived" }],
                        [{ id: "DuplicateDispute" }],
                        [{ id: "MerchantCredit" }],
                        [{ id: "MoneyTransfer" }],
                        [{ id: "NoError" }],
                        [{ id: "NeverPosted" }],
                        [{ id: "OutOfTimeframe" }],
                        [{ id: "PaymentCorrected" }],
                        [{ id: "PostedLate" }],
                        [{ id: "ProofOfAuthorization" }],
                        [{ id: "ResolvedAsProcessed" }],
                        [{ id: "ValidCardPresent" }],
                        [{ id: "Withdrawn" }],
                    ],
                },
            ],
            [{ id: "AreDenyCommentsRequired" }],
        ],
    },
];

export { cards, category };